   (function(){
      emailjs.init("JLN545bRtFF4f-3_U");
   })();

  document.addEventListener('DOMContentLoaded', function() {

    const form = document.getElementById('odsContactForm');
    const submitBtn = document.getElementById('ods-submit-button');
    const originalBtnText = submitBtn.innerText;

    const modalOverlay = document.getElementById('ods-result-modal');
    const modalIcon = document.getElementById('ods-modal-icon');
    const modalTitle = document.getElementById('ods-modal-title');
    const modalBody = document.getElementById('ods-modal-body');
    const modalCloseX = document.getElementById('ods-modal-close-x');
    const modalCloseBtn = document.getElementById('ods-modal-close-btn');
    const orderNumberInput = document.getElementById('ContactFormOrderNumber');
    const orderNumberLabel = document.querySelector('label[for="ContactFormOrderNumber"]');

    function showOdsModal(type, title, message) {
        modalOverlay.classList.add('open');
        modalIcon.className = 'ods-modal-icon'; 
        if (type === 'success') {
            modalIcon.classList.add('success');
            modalIcon.innerHTML = '&#10003;'; 
        } else {
            modalIcon.classList.add('error');
            modalIcon.innerHTML = '&#10005;'; 
        }
        modalTitle.textContent = title;
        modalBody.textContent = message;
    }

    function closeOdsModal() {
        modalOverlay.classList.remove('open');
    }

    modalCloseX.addEventListener('click', closeOdsModal);
    modalCloseBtn.addEventListener('click', closeOdsModal);
    modalOverlay.addEventListener('click', function(e) {
        if (e.target === modalOverlay) {
            closeOdsModal();
        }
    });

    form.addEventListener('submit', function(event) {
      event.preventDefault(); 

      submitBtn.innerText = 'Sending...';
      submitBtn.disabled = true;

      emailjs.sendForm('service_r3lt825', 'template_nvdwb1a', this)
        .then(function() {
            console.log('SUCCESS!');
            
            showOdsModal('success', 'Thank You!', "Thanks for contacting us! We'll get back to you soon.");
            
            submitBtn.innerText = originalBtnText;
            submitBtn.disabled = false;
            form.reset(); 
            
            document.querySelectorAll('.ods-select-head').forEach(el => {
                el.innerText = 'Select an option';
                el.classList.remove('has-value');
            });

            if (orderNumberInput) {
                orderNumberInput.required = false;
                const star = orderNumberLabel.querySelector('span');
                if (star) star.remove();
            }
            
        }, function(error) {
            console.log('FAILED...', error);

            showOdsModal('error', 'Oops!', "Something went wrong. Please try again later.");

            submitBtn.innerText = originalBtnText;
            submitBtn.disabled = false;
        });
    });

    const textarea = document.getElementById('ContactFormMessage');
    if (textarea) {
      const autoResize = (el) => {
        el.style.height = 'auto'; 
        el.style.height = el.scrollHeight + 'px'; 
      };
      textarea.addEventListener('input', function() { autoResize(this); });
      setTimeout(() => autoResize(textarea), 100);
    }

    function toggleOdsSelect(head, body) {
        body.classList.toggle('open');
        head.classList.toggle('open');
        const parentGroup = head.closest('.ods-form-group');
        if (parentGroup) {
            parentGroup.classList.toggle('ods-z-index-active');
        }
    }

    function closeOdsSelect(head, body) {
        if (body) body.classList.remove('open');
        if (head) head.classList.remove('open');
        if (head) {
            const parentGroup = head.closest('.ods-form-group');
            if (parentGroup) {
                parentGroup.classList.remove('ods-z-index-active');
            }
        }
    }

    const issueSelectHead = document.getElementById('ods-issue-head');
    const issueSelectBody = document.getElementById('ods-issue-body');
    const issueHiddenInput = document.getElementById('ContactFormIssueHidden');
    const issueSelectOptions = issueSelectBody ? issueSelectBody.querySelectorAll('.ods-select-option') : [];
    const issueSelectContainer = document.getElementById('ods-issue-select');

    const issuesRequiringOrderNumber = [
        "Order consultation", 
        "Invoice Request", 
        "Return & Refund application"
    ];

    if (issueSelectHead && issueSelectBody) {
        issueSelectHead.addEventListener('click', function(e) {
            e.stopPropagation();
            toggleOdsSelect(issueSelectHead, issueSelectBody);
        });

        issueSelectOptions.forEach(option => {
            option.addEventListener('click', function(e) {
                e.stopPropagation();
                const value = this.getAttribute('data-value');
                const text = this.textContent;
                
                issueSelectHead.textContent = text;
                issueSelectHead.classList.add('has-value');
                issueHiddenInput.value = value;
                
                if (issuesRequiringOrderNumber.includes(value)) {
                    orderNumberInput.required = true;
                    
                    if (!orderNumberLabel.querySelector('span')) {
                        const span = document.createElement('span');
                        span.textContent = ' *';
                        orderNumberLabel.appendChild(span);
                    }
                } else {
                    
                    orderNumberInput.required = false;
                    
                    const span = orderNumberLabel.querySelector('span');
                    if (span) {
                        span.remove();
                    }
                }
                // ---------------------------------------------

                closeOdsSelect(issueSelectHead, issueSelectBody);
            });
        });

        document.addEventListener('click', function(e) {
            if (issueSelectContainer && !issueSelectContainer.contains(e.target)) {
                closeOdsSelect(issueSelectHead, issueSelectBody);
            }
        });
    }

  });